<template>
  <div v-if="question" class="plv-ia-qn-new-question-edit">
    <!-- 单选题,多选题,判断题-->
    <div class="plv-ia-qn-new-question-item" v-if="question.type === QUESTION_TYPE.SINGLE || question.type === QUESTION_TYPE.MULTIPLE || question.type === QUESTION_TYPE.JUDGE">
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.titleLabel')"> {{ t('plvIA.questionnaire.titleLabel') }}</div>
        <div class="plv-ia-qn-new-edit__input__wrap" :class="{'plv-ia-qn-new-input--error': titleError}">
          <input
            type="text"
            class="plv-ia-qn-new-input"
            v-model.trim="question.name"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.titlePlaceholder')"/>
        </div>
        <div class="plv-ia-qn-new-question-type-name" :title="formatQuestionType(question.type)"> {{ formatQuestionType(question.type) }}</div>
      </div>
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.description')"> {{ t('plvIA.questionnaire.description') }}</div>
        <div class="plv-ia-qn-new-edit__input__wrap">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.desc"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.entryDescription')"/>
        </div>
      </div>
      <div v-for="(item, index) in question.options" class="plv-ia-qn-new-question-line" :key="index">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.optionLabel') + index + 1"> {{t('plvIA.questionnaire.optionLabel')}}{{ index + 1 }}：</div>
        <div class="plv-ia-qn-new-edit__input__wrap" :class="{'plv-ia-qn-new-input--error': optionsError.includes(index)}">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.options[index]"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.entryOptionLabel')"/>
        </div>
        <div class="plv-ia-qn-new-question-options-handle">
          <div class="plv-ia-qn-new-question-options-handle-item" @click="optionsHandler(index, 'required')">
            <polyv-icon v-if="question.answer.includes(answerCode(index))"
                        class="plv-ia-qn-new-icon plv-ia-qn-new-icon--size16"
                        color="white"
                        icon="IconRequired" />
            <plv-tooltip v-else placement="top" custom-class="plv-ia-qn-new-tooltip">
              <template slot="content">
                <p class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.setAsCorrectAnswer')">{{ t('plvIA.questionnaire.setAsCorrectAnswer') }}</p>
              </template>
              <polyv-icon class="plv-ia-qn-new-icon plv-ia-qn-new-icon--size16" icon="IconNoRequired" />
            </plv-tooltip>
          </div>
          <div v-if="question.options.length > 2" class="plv-ia-qn-new-question-options-handle-item plv-ia-qn-new-question-bottom-item--delete" @click="optionsHandler(index, 'delete')">
            <plv-tooltip placement="top" custom-class="plv-ia-qn-new-tooltip">
              <template slot="content">
                <p class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.common.delete')">{{ t('plvIA.common.delete') }}</p>
              </template>
              <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconDelete" />
            </plv-tooltip>
          </div>
        </div>
      </div>

      <div class="plv-ia-qn-new-question-bottom" :class="{'plv-ia-qn-new-question-bottom--update': question.isScorable}">
        <div class="plv-ia-qn-new-question-bottom-left">
          <div class="plv-ia-qn-new-question-bottom-item" @click="addOption">
            <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconAdd" />
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.addOption')"> {{t('plvIA.questionnaire.addOption') }}</span>
          </div>
          <div class="plv-ia-qn-new-question-bottom-item" @click="question.isRequired = !question.isRequired">
            <input type="checkbox" v-model="question.isRequired"/>
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.required')">{{t('plvIA.questionnaire.required') }}</span>
          </div>
          <div class="plv-ia-qn-new-question-bottom-item" @click="question.isScorable = !question.isScorable">
            <input type="checkbox" v-model="question.isScorable" @change="setIsScorable"/>
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.setAsScoringQuestion')">{{t('plvIA.questionnaire.setAsScoringQuestion') }}</span>
          </div>
          <div v-if="question.isScorable" class="plv-ia-qn-new-question-bottom-item">
            <input class="plv-ia-qn-new-input plv-ia-qn-new-question-bottom-item-score-input" type="number" v-model="question.score"/>
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.score')">{{t('plvIA.questionnaire.score') }}</span>
          </div>
        </div>
        <div class="plv-ia-qn-new-question-bottom-right">
          <div class="plv-ia-qn-new-question-bottom-item plv-ia-qn-new-question-bottom-item--delete" @click="deleteOption">
            <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconDelete" />
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.common.delete')">{{t('plvIA.common.delete') }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 问答题-->
    <div v-if="question.type === QUESTION_TYPE.TEXT">
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.titleLabel')"> {{ t('plvIA.questionnaire.titleLabel') }}</div>
        <div class="plv-ia-qn-new-edit__input__wrap" :class="{'plv-ia-qn-new-input--error': titleError}">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.name"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.titlePlaceholder')"/>
        </div>
        <div class="plv-ia-qn-new-question-type-name" :title="t('plvIA.questionnaire.fillInTheBlank')">{{t('plvIA.questionnaire.fillInTheBlank')}}</div>
      </div>
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.description')"> {{t('plvIA.questionnaire.description')}}</div>
        <div class="plv-ia-qn-new-edit__input__wrap">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.desc"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.entryDescription')"/>
        </div>
      </div>
      <div class="plv-ia-qn-new-question-bottom">
        <div class="plv-ia-qn-new-question-bottom-left">
          <div class="plv-ia-qn-new-question-bottom-item" @click="question.isRequired = !question.isRequired">
            <input type="checkbox" v-model="question.isRequired"/>
            <span class="plv-ia-qn-new-question-handle-label" :title="t('plvIA.questionnaire.required')">{{t('plvIA.questionnaire.required')}}</span>
          </div>
        </div>
        <div class="plv-ia-qn-new-question-bottom-right">
          <div class="plv-ia-qn-new-question-bottom-item" @click="deleteOption">
            <polyv-icon class="plv-ia-qn-new-icon--size16 plv-ia-qn-new-question-bottom-item--delete" icon="IconDelete" />
            <span class="plv-ia-qn-new-question-handle-label"
                  :title="t('plvIA.common.delete')">{{t('plvIA.common.delete')}}</span>
          </div>
        </div>
      </div>

    </div>
    <!-- 评分题-->
    <div v-if="
      question.type ===
        QUESTION_TYPE.STAR
        ||
        question.type ===
        QUESTION_TYPE.STAR_NUMBER">
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title=" t('plvIA.questionnaire.titleLabel')"> {{ t('plvIA.questionnaire.titleLabel') }}</div>
        <div class="plv-ia-qn-new-edit__input__wrap" :class="{'plv-ia-qn-new-input--error': titleError}">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.name"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.titlePlaceholder')"/>
        </div>
        <div class="plv-ia-qn-new-question-type-name" :title="formatQuestionType(question.type)"> {{ formatQuestionType(question.type) }}</div>
      </div>
      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label" :title="t('plvIA.questionnaire.description')"> {{t('plvIA.questionnaire.description')}} </div>
        <div class="plv-ia-qn-new-edit__input__wrap">
          <input
            class="plv-ia-qn-new-input"
            v-model="question.desc"
            :maxlength="maxLen.questionTitle"
            :placeholder="t('plvIA.questionnaire.entryDescription')"/>
        </div>
      </div>

      <div class="plv-ia-qn-new-question-line">
        <div class="plv-ia-qn-new-question-label"></div>
        <div class="plv-ia-qn-new-edit__input__wrap">
          <template v-if="question.type === QUESTION_TYPE.STAR">
            <Star type="star" disabled/>
          </template>
          <template v-if="question.type === QUESTION_TYPE.STAR_NUMBER">
            <Star type="number" disabled/>
          </template>
        </div>
      </div>
      <div class="plv-ia-qn-new-question-bottom" style="margin-top: 0;">
        <div class="plv-ia-qn-new-question-bottom-left">
          <div class="plv-ia-qn-new-question-bottom-item">
            <input type="checkbox" :checked="question.type === QUESTION_TYPE.STAR_NUMBER"  @change="changeStarType"/>
            <span>{{ t('plvIA.questionnaire.changeToNumericScoring') }}</span>
            <plv-tooltip placement="top" custom-class="plv-ia-qn-new-tooltip">
              <template slot="content">
                <p class="plv-ia-qn-new-question-tip">{{ t('plvIA.questionnaire.changeToNumericScoringTip') }} </p>
                <p class="plv-ia-qn-new-question-tip">{{ t('plvIA.questionnaire.numericScoring') }}</p>
              </template>
              <span class="plv-ia-qn-new-question-bottom-icon--tip"></span>
            </plv-tooltip>
          </div>
          <div class="plv-ia-qn-new-question-bottom-item">
            <input type="checkbox" v-model="question.isRequired"/>
            <span>{{ t('plvIA.questionnaire.required') }}</span>
          </div>
        </div>

        <div class="plv-ia-qn-new-question-bottom-right">
          <div class="plv-ia-qn-new-question-bottom-item plv-ia-qn-new-question-bottom-item--delete" @click="deleteOption">
            <polyv-icon class="plv-ia-qn-new-icon--size16" icon="IconDelete" />
            <span>{{ t('plvIA.common.delete') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QUESTION_TYPE, maxLen } from '@/assets/app/questionnaire/helper';
import { strLen } from '@polyv/utils/src/string';
import { Tooltip } from '@polyv/polyv-ui';
import Star from '@/components/star/star';
import Locale from '@/mixins/locale';
import { PolyvIcon } from '@polyv/icons-vue/icon';
import commonMixin from '../../app-mixin';

export default {
  name: 'QuestionEdit',
  components: {
    'plv-tooltip': Tooltip,
    Star,
    PolyvIcon
  },
  mixins: [Locale, commonMixin],
  props: {
    questionData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      QUESTION_TYPE,
      maxLen,
      question: this.questionData,
      titleError: false,
      optionsError: []
    };
  },
  watch: {
    question: {
      handler(question) {
        this.$emit('update-data', question);
      },
      deep: true,
    },
  },
  methods: {
    strLen,
    formatQuestionType(type) {
      switch (type) {
        case QUESTION_TYPE.SINGLE:
          return this.t('plvIA.questionnaire.singleChoice');
        case QUESTION_TYPE.MULTIPLE:
          return this.t('plvIA.questionnaire.multipleChoice');
        case QUESTION_TYPE.JUDGE:
          return this.t('plvIA.questionnaire.judgementQuestions');
        case QUESTION_TYPE.STAR:
          return this.t('plvIA.questionnaire.starRatingQuestions');
        default:
          return '未知题型';
      }
    },
    optionsHandler(index, type) {
      const { question, QUESTION_TYPE } = this;
      if (type === 'delete') {
        question.options.splice(index, 1);
      } else if (type === 'required') {
        if (question.type === QUESTION_TYPE.SINGLE) {
          if (question.answer !== '') {
            question.answer = '';
          } else {
            question.answer = this.answerCode(index);
          }
        } else {
          // 多选题
          const answer = this.answerCode(index);
          if (question.answer.includes(answer)) {
            question.answer = question.answer.replace(answer, '');
          } else {
            question.answer += answer;
          }
        }
      }
    },
    answerCode(index) {
      return String.fromCharCode(97 + index);
    },
    setIsScorable(e) {
      const checked = e.target.checked;
      // 如果是非得分题，清空答案
      if (!checked) {
        this.question.answer = '';
        this.question.score = '';
      }
    },
    changeStarType(e) {
      const checked = e.target.checked;
      // 如果是非得分题，清空答案
      this.question.type = checked ? QUESTION_TYPE.STAR_NUMBER : QUESTION_TYPE.STAR;
    },
    addOption() {
      const { question, QUESTION_TYPE } = this;
      if (question.type === QUESTION_TYPE.JUDGE) {
        if (question.options.length >= 5) {
          this.$iaMessage.default(this.t('plvIA.questionnaire.optionsMax') + 5);
          return;
        }
        this.question.options.push('');
      } else {
        if (question.options.length >= 10) {
          this.$iaMessage.default(this.t('plvIA.questionnaire.optionsMax') + 10);
          return;
        }
        this.question.options.push('');
      }
    },
    deleteOption() {
      this.$emit('delete');
    }
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-question-edit {
  width: 100%;
  background-color: #F6F6F6;
  padding: 20px 0 4px;
  margin-top: 20px;
  border-top: 1px dashed #e7e7e7;
  border-bottom: 1px dashed #e7e7e7;
  .plv-ia-qn-new-question-type-name {
    max-width: 60px;
    margin-left: 8px;
    color: #9E9E9E;
    // 超出隐藏
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .plv-ia-qn-new-question-line + .plv-ia-qn-new-question-line {
    margin-top: 12px;
  }

  .plv-ia-qn-new-question-line {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 15px;

    .plv-ia-qn-new-question-label {
      width: 60px;
      font-size: 14px;
      color: #333300;
      // 超出隐藏
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .plv-ia-qn-new-question-options-handle {
      flex: 1;
      height: 100%;
      display: flex;
      padding-top: 2px;
      align-items: center;
    }

    .plv-ia-qn-new-question-options-handle-item {
      margin-left: 8px;
      cursor: pointer;
    }
  }

  .plv-ia-qn-new-edit__input__wrap {
    width: 380px;
    box-sizing: border-box;

    input {
      box-sizing: border-box;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 8px;
    }
  }
  .plv-ia-qn-new-question-bottom {
    display: flex;
    align-items: center;
    height: 40px;
    margin-top: 8px;
    padding-left: 70px;
    margin-bottom: 5px;
    justify-content: space-between;
    width: 380px;
    .plv-ia-qn-new-question-bottom-left {
      display: flex;
      align-items: center;
    }
    .plv-ia-qn-new-question-bottom-right {
      display: flex;
      align-items: center;
    }
    .plv-ia-qn-new-question-bottom-item:hover {
      color: var(--interactBlue);
      cursor: pointer;
      filter: drop-shadow(0 0 0 var(--interactBlue));
      svg {
        path {
          fill: var(--interactBlue);
        }
      }
    }
    .plv-ia-qn-new-question-bottom-item {
      display: flex;
      align-items: center;
      span {
        margin-left: 7px;
      }
    }
    .plv-ia-qn-new-question-bottom-item + .plv-ia-qn-new-question-bottom-item {
      margin-left: 20px;
    }
    .plv-ia-qn-new-question-bottom-item-score-input {
      width: 24px;
      height: 32px;
    }
  }
  .plv-ia-qn-new-question-bottom-icon--tip {
    width: 14px;
    height: 14px;
    background: url('../images/icon-tip.png') no-repeat;
    background-size: 100% 100%;
  }
  .plv-ia-qn-new-question-bottom--update {
    width: auto;
    justify-content: flex-start;
    .plv-ia-qn-new-question-bottom-right {
      .plv-ia-qn-new-question-bottom-item {
        margin-left: 30px;
      }
    }
  }
}
.plv-ia-qn-new-question-handle-label {
  // 超出隐藏
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.plv-ia-qn-new-question-bottom-item--delete:hover {
  color: #FC1212 !important;
  cursor: pointer;
  svg {
    path {
      fill: #FC1212 !important;
    }
  }
}
.plv-ia-qn-new-question-tip {
  font-size: 14px;
}
.plv-ia-qn-new-question-tip + .plv-ia-qn-new-question-tip {
  margin-top: 4px;
}
.plv-ia-qn-new-icon--size16 {
  width: 16px !important;
  height: 28px !important;
  box-sizing: border-box;
  svg {
    width: 16px !important;
    height: 16px !important;
  }
}
</style>
